import React from "react";
import { Link } from "react-router-dom";


export default function Sidebar() {
  return (
    <div className="app-menu navbar-menu">
      {/* LOGO */}
      <div className="navbar-brand-box">
        <a className="logo logo-dark">
          <span className="logo-sm">
            <img
              src="../assets/images/perfectx_web_logo_black.svg"
              alt=""
              height={22}
            />
          </span>
          <span className="logo-lg">
            <img
              src="../assets/images/perfectx_web_logo.svg"
              alt=""
              height={50}
            />
          </span>
        </a>
        <a className="logo logo-light">
          <span className="logo-sm">
            <img
              src="../assets/images/perfectx_web_logo_black.svg"
              alt=""
              height={22}
            />
          </span>
          <span className="logo-lg">
            <img
              src="../assets/images/perfectx_web_logo.svg"
              alt=""
              height={50}
            />
          </span>
        </a>
      </div>

      {/* Sidebar User Section */}
      <div className="dropdown sidebar-user m-1 rounded">
        <button
          type="button"
          className="btn material-shadow-none"
          id="page-header-user-dropdown"
          data-bs-toggle="dropdown"
          data-bs-auto-close="outside"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span className="d-flex align-items-center gap-2">
            <img
              className="rounded header-profile-user"
              src="assets/images/users/avatar-1.jpg"
              alt="Header Avatar"
            />
          </span>
        </button>
      </div>

      {/* Sidebar Navigation */}
      <div id="scrollbar" className="scroll-container">
        <div className="container-fluid">
          <ul className="navbar-nav" id="navbar-nav">
            {/* Dashboard Menu */}
            <li className="menu-title">
              <span>Menu</span>
            </li>
            <li className="nav-item">
              <Link className="nav-link menu-link" to="/dashbord">
                <i className="ri-dashboard-2-line" /> <span>Dashboards</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link menu-link" to="/memberreport">
                <i class="bi bi-highlights" /> <span>Member Report</span>
              </Link>
            </li>

            {/* Reports Menu */}
            <li className="nav-item">
              <a
                className="nav-link menu-link"
                href="#sidebarReports"
                data-bs-toggle="collapse"
                data-bs-auto-close="outside"
              >
                <i className="ri-folder-line" /> <span>Reports</span>
              </a>
              <div className="collapse menu-dropdown" id="sidebarReports">
                <ul className="nav nav-sm flex-column">
                  <li className="nav-item">
                    <Link to="/stakingsidbarreport" className="nav-link">
                      Staking Report
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/levelrewardsidbar" className="nav-link">
                      Level Reward Report
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/poolsidebar" className="nav-link">
                      Pool Reward
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/weeklysidebar" className="nav-link">
                      Weekly Reward
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/roiofroi" className="nav-link">
                      Roi Roi
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/primesidebar" className="nav-link">
                      Prime Reward
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

            {/* Pools Packages Menu */}
            <li className="nav-item">
              <a
                className="nav-link menu-link"
                href="#sidebarPackages1122"
                data-bs-toggle="collapse"
                data-bs-auto-close="outside"
              >
                <i className="ri-money-dollar-circle-line" /> <span>Pools Packages</span>
              </a>
              <div className="collapse menu-dropdown" id="sidebarPackages1122">
                <ul className="nav nav-sm flex-column">
                  <li className="nav-item">
                    <Link to="/one" className="nav-link">
                      Pool: 1
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/two" className="nav-link">
                      Pool: 2
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/three" className="nav-link">
                      Pool: 3
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/four" className="nav-link">
                      Pool: 4
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

            {/* Packages Menu */}
            <li className="nav-item">
              <a
                className="nav-link menu-link"
                href="#sidebarPackages"
                data-bs-toggle="collapse"
                data-bs-auto-close="outside"
              >
                <i class="bi bi-backpack" /> <span>Packages</span>
              </a>
              <div className="collapse menu-dropdown" id="sidebarPackages">
                <ul className="nav nav-sm flex-column">
                  <li className="nav-item">
                    <Link to="/fifty" className="nav-link">
                      $50
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/hundred" className="nav-link">
                      $100
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/fivehundred" className="nav-link">
                      $500
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/thousand" className="nav-link">
                      $1000
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

            {/* Pools Menu */}
            <li className="nav-item">
              <a
                className="nav-link menu-link"
                href="#sidebarpool"
                data-bs-toggle="collapse"
                data-bs-auto-close="outside"
              >
                <i className="ri-wallet-2-line" /> <span>Deposits</span>
              </a>
              <div className="collapse menu-dropdown" id="sidebarpool">
                <ul className="nav nav-sm flex-column">
                  <li className="nav-item">
                    <Link to="/pendingdeposits" className="nav-link">
                      Pending Deposits
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/deposits" className="nav-link">
                      Deposits
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

            {/* Withdrawal Menu */}
            <li className="nav-item">
              <a
                className="nav-link menu-link"
                href="#sidebarWithdrawal"
                data-bs-toggle="collapse"
                data-bs-auto-close="outside"
              >
                <i className="ri-wallet-line" /> <span>Withdrawal</span>
              </a>
              <div className="collapse menu-dropdown" id="sidebarWithdrawal">
                <ul className="nav nav-sm flex-column">
                 
                  <li className="nav-item">
                    <Link to="/withdrwalsidebar" className="nav-link">
                      Withdrawal
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

            {/* Manual Operations Menu */}
           
            {/* <li className="nav-item">
              <Link className="nav-link menu-link" to="/adminDeposit">
                <i className="bi bi-bag-fill" /> <span>Admin Deposit</span>
              </Link>
            </li> */}


            <li className="nav-item">
              <Link className="nav-link menu-link" to="/pools">
                <i class="bi bi-boxes" /> <span>Pools</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link menu-link" to="/userlistbyDate">
                <i class="bi bi-people-fill" /> <span>User List</span>
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link menu-link" to="/userBalance">
                <i class="bi bi-cash-stack" /> <span>User Balance</span>
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link className="nav-link menu-link" to="/adminpurchase">
                <i class="bi bi-clipboard2-data" /> <span>Admin Purchase</span>
              </Link>
            </li> */}
            
          </ul>
        </div>
      </div>
    </div>
  );
}
